module.exports = __webpack_public_path__ + "static/media/google-play-store.4734a8cf.webp";